module.exports = __webpack_public_path__ + "static/img/boatWest.bd2618f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/boatWest.png
// module id = /Dwf
// module chunks = 3